import { parseMoneyToCents } from './formatters';

export function createPaymentRow({
    name = 'Crédito',
    installments = 1,
    amountCents = 0,
    paymentDate = new Date(),
} = {}) {
    return {
        key: `pay-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
        name,
        installments: name === 'Crédito' ? (installments || 1) : 1,
        amountReais: amountCents > 0 ? (amountCents / 100).toFixed(2) : '',
        paymentDate: paymentDate instanceof Date && !Number.isNaN(paymentDate.getTime())
            ? new Date(paymentDate.getTime())
            : new Date(),
    };
}

export function paymentsFromApiMethods(methods, {
    totalAmountCents = 0,
    fallbackDate = new Date(),
} = {}) {
    if (!Array.isArray(methods) || methods.length === 0) {
        return [createPaymentRow({ amountCents: totalAmountCents, paymentDate: fallbackDate })];
    }

    return methods.map((method) => {
        const name = method?.name || 'Crédito';
        const amountCents = Number(method?.amount) || 0;
        const paymentDate = method?.payment_date
            ? new Date(method.payment_date)
            : (fallbackDate instanceof Date ? new Date(fallbackDate.getTime()) : new Date());
        return createPaymentRow({
            name,
            installments: method?.installments || 1,
            amountCents: amountCents > 0 ? amountCents : (methods.length === 1 ? totalAmountCents : 0),
            paymentDate: Number.isNaN(paymentDate.getTime()) ? fallbackDate : paymentDate,
        });
    });
}

export function paymentRowsTotalCents(payments) {
    if (!Array.isArray(payments)) {
        return 0;
    }
    return payments.reduce((sum, row) => sum + parseMoneyToCents(row?.amountReais), 0);
}

export function buildPaymentMethodsPayload(payments) {
    if (!Array.isArray(payments)) {
        return [];
    }
    return payments
        .filter((row) => String(row?.name || '').trim())
        .map((row) => {
            const name = String(row.name).trim();
            const payload = {
                name,
                installments: name === 'Crédito' ? (Number(row.installments) || 1) : 1,
                amount: parseMoneyToCents(row.amountReais),
            };
            if (row.paymentDate instanceof Date && !Number.isNaN(row.paymentDate.getTime())) {
                payload.payment_date = row.paymentDate.toISOString();
            }
            return payload;
        });
}

export function aggregatePaymentDateFromRows(payments) {
    if (!Array.isArray(payments) || payments.length === 0) {
        return null;
    }
    let latest = null;
    payments.forEach((row) => {
        if (!(row?.paymentDate instanceof Date) || Number.isNaN(row.paymentDate.getTime())) {
            return;
        }
        if (!latest || row.paymentDate > latest) {
            latest = row.paymentDate;
        }
    });
    return latest;
}

export function syncSinglePaymentAmount(payments, totalAmountCents) {
    if (!Array.isArray(payments) || payments.length !== 1) {
        return payments;
    }
    const [only] = payments;
    return [{
        ...only,
        amountReais: totalAmountCents > 0 ? (totalAmountCents / 100).toFixed(2) : '',
    }];
}

export function validatePaymentRows(payments, totalAmountCents) {
    if (!Array.isArray(payments) || payments.length === 0) {
        return 'Informe ao menos um pagamento.';
    }
    for (let i = 0; i < payments.length; i += 1) {
        const row = payments[i];
        if (!String(row?.name || '').trim()) {
            return `Informe o meio do pagamento ${i + 1}.`;
        }
        const cents = parseMoneyToCents(row.amountReais);
        if (cents <= 0) {
            return `Informe o valor do pagamento ${i + 1}.`;
        }
        if (!(row.paymentDate instanceof Date) || Number.isNaN(row.paymentDate.getTime())) {
            return `Informe a data do pagamento ${i + 1}.`;
        }
    }
    const sum = paymentRowsTotalCents(payments);
    if (totalAmountCents > 0 && Math.abs(sum - totalAmountCents) > 1) {
        return `A soma dos pagamentos (${(sum / 100).toFixed(2)}) deve ser igual ao total da venda (${(totalAmountCents / 100).toFixed(2)}).`;
    }
    return null;
}
